import React from "react";
import { TbTrash } from "react-icons/tb";

export default function UploadImagem({
    label,
    name,
    value,
    url,
    onChange,
    onRemove
}) {

    const handleFile = (e) => {
        const file = e.target.files[0];

        if (!file) return;

        if (!file.type.includes("image")) {
            alert("Selecione uma imagem válida.");
            return;
        }

        const reader = new FileReader();

        reader.onloadend = () => {
            onChange({
                name,
                base64: reader.result,
                fileName: file.name
            });
        };

        reader.readAsDataURL(file);
    };

    const preview = value || url;

    return (
        <div className="mb-3">
            <label className="form-label">{label}</label>

            <div
                style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "12px",
                    padding: "10px",
                    border: "1px solid #ddd",
                    borderRadius: "10px",
                    background: "#f8f9fa"
                }}
            >

                {/* Preview */}
                <div
                    style={{
                        width: "70px",
                        height: "70px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        background: "#fff",
                        border: "1px solid #ddd",
                        borderRadius: "8px",
                        overflow: "hidden"
                    }}
                >
                    {preview ? (
                        <img
                            src={preview}
                            alt="preview"
                            style={{
                                width: "100%",
                                height: "100%",
                                objectFit: "contain"
                            }}
                        />
                    ) : (
                        <span style={{ fontSize: "12px", color: "#999", textAlign: "center" }}>
                            Sem imagem
                        </span>
                    )}
                </div>

                {/* Info */}
                <div style={{ flex: 1 }}>
                    <div style={{ fontSize: "14px", color: "#666" }}>
                        {preview ? "Arquivo selecionado" : "Nenhum arquivo selecionado"}
                    </div>

                    <label
                        style={{
                            marginTop: "5px",
                            display: "inline-block",
                            cursor: "pointer",
                            padding: "5px 10px",
                            borderRadius: "6px",
                            border: "1px solid #ccc",
                            background: "#fff"
                        }}
                    >
                        {preview ? "Trocar imagem" : "Escolher arquivo"}

                        <input
                            type="file"
                            name={name}
                            style={{ display: "none" }}
                            onChange={handleFile}
                        />
                    </label>
                </div>

                {/* Remover */}
                {value && (
                    <button
                        type="button"
                        onClick={() => onRemove(name)}
                        style={{
                            border: "none",
                            background: "transparent",
                            color: "red",
                            cursor: "pointer"
                        }}
                    >
                        <TbTrash style={{fontSize: '20px'}}/>
                    </button>
                )}
            </div>
        </div>
    );
}